package com.wintermar.inspection.feature.presentation.auth.login

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import com.wintermar.inspection.core.ui.component.button.Button
import com.wintermar.inspection.core.ui.component.button.variant.ButtonVariant
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.widget.InputWithLabel
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.button_login_label
import inspection.composeapp.generated.resources.title_login_screen
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@Composable
fun LoginScreen(
    viewModel: LoginViewModel = koinViewModel(),
    onLoginSuccess: () -> Unit
) {
    val space = LocalAppTheme.current.dimension.spacing
    val state = viewModel.state

    LaunchedEffect(Unit) {
        state.onLoginSuccess = onLoginSuccess
    }

    Column(
        modifier = Modifier.fillMaxSize().padding(space.space5),
        verticalArrangement = Arrangement.spacedBy(
            space = space.space5,
            alignment = Alignment.CenterVertically
        )
    ) {
        Text(
            text = stringResource(Res.string.title_login_screen),
            style = LocalAppTheme.current.textStyle.title.s,
            fontWeight = FontWeight.Bold,
            color = LocalAppTheme.current.color.text.brand
        )

        InputWithLabel(
            inputState = state.email,
            modifier = Modifier.fillMaxWidth()
        )

        InputWithLabel(
            inputState = state.password,
            modifier = Modifier.fillMaxWidth()
        )

        Button(
            buttonVariant = ButtonVariant.LargePrimary,
            text = stringResource(Res.string.button_login_label),
            isLoading = state.isLoading,
            hideTextWhenLoading = true,
            modifier = Modifier.fillMaxWidth(),
            onClick = {
                state.onLoginClicked()
            })

        Spacer(modifier = Modifier.height(space.space10))
    }
}
